module.exports = __webpack_public_path__ + "static/media/popcorn-happy.451e0e0c.png";